import { BiSearch } from "react-icons/bi";
import { HiMenu } from "react-icons/hi";
import { AiOutlineUser } from "react-icons/ai";
import { RiHome5Line, RiNotification3Line } from "react-icons/ri";
import { TbPencilMinus } from "react-icons/tb";

function getNavBarOptions({ loggedInUser, notificationCount }) {
  return [
    {
      value: "HOME",
      label: "Home",
      icon: <RiHome5Line />,
      link: "/",
    },
    {
      value: "CREATE",
      label: "Create", //notificationCount
      icon: <TbPencilMinus />,
      link: "/select-post-type",
    },
    {
      value: "NOTIFICATIONS",
      label: "Notifications",
      icon: <RiNotification3Line />,
      link: "/notifications",
      badge: notificationCount,
    },
    {
      value: "SEARCH",
      label: "Search",
      icon: <BiSearch />,
      link: "/search",
    },
    {
      value: "PROFILE",
      label: "Profile",
      icon: <AiOutlineUser />,
      link: loggedInUser ? `/u/${loggedInUser.username}` : "/",
    },
    {
      value: "MORE",
      label: "More",
      icon: <HiMenu />,
      link: "/options",
    },
  ];
}

export default getNavBarOptions;
